import React from 'react';
import { motion } from 'framer-motion';
import { Container } from '../ui/Container';
import { Button } from '../ui/Button';
import { TechnicalGrid } from '../ui/TechnicalGrid';
import { StatusIndicator } from '../ui/StatusIndicator';
import { AnimatedCounter } from '../ui/AnimatedCounter';
import { ArrowRight, Phone, Mail, Clock, TrendingUp } from 'lucide-react';
export function CTA() {
  return <section className="relative overflow-hidden bg-dashboard-surface text-center py-24 border-t border-dashboard-border" data-id="element-59">
      <TechnicalGrid data-id="element-60">
        <Container className="relative z-10" data-id="element-61">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} data-id="element-62">
            {/* Final proof point */}
            <div className="flex items-center justify-center gap-3 mb-8" data-id="element-63">
              <StatusIndicator status="online" label="System Active" data-id="element-64" />
              <span className="text-xs font-mono text-tech-blue uppercase" data-id="element-65">
                // AVERAGE_CLIENT_RESULTS
              </span>
            </div>

            {/* Results metrics */}
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-3xl mx-auto mb-12" data-id="element-66">
              <motion.div className="metric-card" initial={{
              opacity: 0,
              y: 20
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              delay: 0.1,
              duration: 0.5
            }} data-id="element-67">
                <Clock className="w-6 h-6 text-tech-green mx-auto mb-3" data-id="element-68" />
                <AnimatedCounter value={20} suffix="+ hrs" className="text-3xl font-black text-tech-green" data-id="element-69" />
                <p className="text-xs text-dashboard-muted font-mono mt-2" data-id="element-70">
                  saved per week
                </p>
              </motion.div>
              <motion.div className="metric-card" initial={{
              opacity: 0,
              y: 20
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              delay: 0.2,
              duration: 0.5
            }} data-id="element-71">
                <TrendingUp className="w-6 h-6 text-tech-blue mx-auto mb-3" data-id="element-72" />
                <AnimatedCounter value={70} suffix="%" className="text-3xl font-black text-tech-blue" data-id="element-73" />
                <p className="text-xs text-dashboard-muted font-mono mt-2" data-id="element-74">
                  admin reduction
                </p>
              </motion.div>
              <motion.div className="metric-card" initial={{
              opacity: 0,
              y: 20
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              delay: 0.3,
              duration: 0.5
            }} data-id="element-75">
                <div className="text-2xl font-black text-tech-green mx-auto mb-3" data-id="element-76">
                  3-6
                </div>
                <AnimatedCounter value={0} suffix=" months" className="text-3xl font-black text-tech-green" data-id="element-77" />
                <p className="text-xs text-dashboard-muted font-mono mt-2" data-id="element-78">
                  to full ROI
                </p>
              </motion.div>
            </div>

            <h2 className="text-4xl font-black tracking-tight text-dashboard-text sm:text-5xl mb-6" data-id="element-79">
              Stop Wasting Time on Admin.
              <br data-id="element-80" />
              <span className="text-gradient-tech" data-id="element-81">
                Start Delivering Projects.
              </span>
            </h2>
            <p className="text-xl text-dashboard-muted max-w-3xl mx-auto mb-10 leading-relaxed font-mono" data-id="element-82">
              Book a 30-minute discovery call. We'll show you exactly how much
              time and money you're losing—and how to fix it.
            </p>

            <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-10" data-id="element-83">
              <Button variant="cta" size="xl" className="w-full sm:w-auto group" data-id="element-84">
                <span className="font-mono" data-id="element-85">BOOK_DISCOVERY_CALL()</span>
                <ArrowRight className="ml-2 h-5 w-5 transition-transform group-hover:translate-x-1" data-id="element-86" />
              </Button>
            </div>

            {/* Alternative contact methods */}
            <div className="flex flex-col sm:flex-row items-center justify-center gap-6 text-sm text-dashboard-muted font-mono" data-id="element-87">
              <div className="flex items-center gap-2" data-id="element-88">
                <Phone className="h-4 w-4" data-id="element-89" />
                <span data-id="element-90">Prefer to call?</span>
                <a href="tel:+61892266399" className="text-tech-blue font-semibold hover:text-tech-green transition-colors" data-id="element-91">
                  +61 8 9226 6399
                </a>
              </div>
              <div className="hidden sm:block text-dashboard-border" data-id="element-92">|</div>
              <div className="flex items-center gap-2" data-id="element-93">
                <Mail className="h-4 w-4" data-id="element-94" />
                <a href="mailto:hello@laisolutions.com.au" className="text-tech-blue font-semibold hover:text-tech-green transition-colors" data-id="element-95">
                  hello@laisolutions.com.au
                </a>
              </div>
            </div>

            <p className="mt-10 text-sm text-dashboard-muted font-mono" data-id="element-96">
              <span className="text-tech-green" data-id="element-97">✓</span> No obligation
              <span className="mx-3" data-id="element-98">|</span>
              <span className="text-tech-green" data-id="element-99">✓</span> No sales pressure
              <span className="mx-3" data-id="element-100">|</span>
              <span className="text-tech-green" data-id="element-101">✓</span> Just honest engineering
              talk
            </p>
          </motion.div>
        </Container>
      </TechnicalGrid>
    </section>;
}